var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21516",
    "data-name": "Group 21516",
    transform: "translate(-0.468 -0.468)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0.468 0.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "google-logo-search-new-svgrepo-com",
    transform: "translate(11.836 11.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101450",
    "data-name": "Path 101450",
    d: "M19.9,16A6.214,6.214,0,0,1,7.842,18.107L4.285,20.953A10.627,10.627,0,0,0,24.317,16",
    transform: "translate(-3.053 -5.368)",
    fill: "#00ac47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101451",
    "data-name": "Path 101451",
    d: "M23.108,16A6.21,6.21,0,0,1,20.5,21.054l3.516,2.813A10.6,10.6,0,0,0,27.521,16",
    transform: "translate(-6.257 -5.368)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101452",
    "data-name": "Path 101452",
    d: "M7.163,14.78a6.177,6.177,0,0,1,.375-2.107L3.982,9.828a10.573,10.573,0,0,0,0,9.905l3.557-2.845a6.177,6.177,0,0,1-.375-2.107Z",
    transform: "translate(-2.75 -4.148)",
    fill: "#ffba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101453",
    "data-name": "Path 101453",
    d: "M8.718,13.374Z",
    transform: "translate(-3.929 -4.849)",
    fill: "#2ab2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101454",
    "data-name": "Path 101454",
    d: "M13.685,7.163a6.178,6.178,0,0,1,3.657,1.2L20.6,5.323A10.6,10.6,0,0,0,4.285,8.429l3.557,2.845a6.223,6.223,0,0,1,5.843-4.112Z",
    transform: "translate(-3.053 -2.75)",
    fill: "#ea4435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101455",
    "data-name": "Path 101455",
    d: "M8.718,18.626Z",
    transform: "translate(-3.929 -5.887)",
    fill: "#2ab2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101456",
    "data-name": "Path 101456",
    d: "M26.731,14.8v.8l-1.805,2.808H16.5V14h9.428A.8.8,0,0,1,26.731,14.8Z",
    transform: "translate(-5.467 -4.973)",
    fill: "#4285f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8c80143a86bcd970e52005ca6f8b1c33.svg";
export { ForwardRef as ReactComponent };